/*  ==========================================================================
    Global
    ==========================================================================  */

var domain = $("body").data("domain");
var page = $("body").data("page");

function getCookie($elem) {
	let name = $elem + "=";
	let decodedCookie = decodeURIComponent(document.cookie);
	let ca = decodedCookie.split(';');
	for(let i = 0; i <ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) == ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
}

$(document).ready(function() {

/////////////////////
// Menu responsive
////////////////////

$('.bg_behind_menu').click(function(e){
	e.preventDefault();
  animMenuOut();
});

$(".hamburger").click(function(e){
	e.preventDefault();
	if ($(this).hasClass('open')) {
		animMenuOut();
	}else {
		animMenuIn();
	}
});

function animMenuIn(){
	$("body").addClass('overflow_hidden');
	$(".hamburger, .menu_to_open, header, .bg_behind_menu").addClass('open');
	var tl2 = gsap.timeline();
	tl2.to('.bg_behind_menu', {opacity: 0.9 , duration: .3, ease: Power2.easeOuteaseOut}, 'start');
	tl2.to('.menu_to_open', {right:0 , duration: .3, ease: Power2.easeOuteaseOut}, 'start');
	tl2.to('.i_a_1', {top: 8, rotation: 45, duration: .5, ease: Elastic.easeOut.config(1, 0.75)}, 'start');
	tl2.to('.i_a_3', {top: 8, rotation: -45, duration: .5, ease: Elastic.easeOut.config(1, 0.75)}, 'start');
	tl2.to('.i_a_2', {opacity: 0 , duration: .1, ease: Power2.easeOuteaseOut}, 'start');
}
function animMenuOut(){
	$("body").removeClass('overflow_hidden');
	var tl3 = gsap.timeline({onComplete: removeOpen});
	tl3.to('.bg_behind_menu', {opacity: 0 , duration: .3, ease: Power2.easeOuteaseOut}, 'start');
	tl3.to('.menu_to_open', {right:'-100%' , duration: .3, ease: Power2.easeOuteaseOut}, 'start');
	tl3.to('.i_a_1', {top: 0, rotation: 0, duration: .5, ease: Elastic.easeOut.config(1, 0.75)}, 'start');
	tl3.to('.i_a_3', {top: 16, rotation: 0, duration: .5, ease: Elastic.easeOut.config(1, 0.75)}, 'start');
	tl3.to('.i_a_2', {opacity: 1 , duration: .2, ease: Power2.easeOuteaseOut}, 'start');
}
function removeOpen(){
	$(".hamburger, .menu_to_open, header, .bg_behind_menu").removeClass('open');
}

// Initialisation Slick
	if (page == 'home_view') {
		$('.slider').slick({
			dots: true,
			infinite: true,
			fade: true,
			adaptiveHeight: true
		});
	}

// Initialisation Selectric
	if (page == 'subscription_view') {
		$('select').selectric();
	}

//////////////////////////////////
// Slick and select special
/////////////////////////////////
// Initialisation Slick
	if (page == 'contact_view') {
		$('select').selectric();
		$('.to_show_switch').on('change', function() {
			var value = $(this).val();
			if (value == 'Formation') {
				$('.input_toshow').addClass('active');
			}else {
				$('.input_toshow').removeClass('active');
			}
		});
	}

//////////////////
// Masonry Document
/////////////////

// Initialisation Masonry
	if (page == 'info_view') {
		$('.grid').masonry({
			itemSelector: '.grid-item',
			columnWidth: '.grid-sizer',
			horizontalOrder: true,
			percentPosition: true
		})
	}

////////////////////////////////////////
// Scroll menu on formation pages
////////////////////////////////////////

// Formation_detail function
	$('.cta_aside').click(function(e){
		e.preventDefault();
		$('.cta_aside').removeClass('active');
		$(this).addClass('active');
		var scroll = $(this).data("scroll");
		var totop = $(".side_content h1[data-scroll="+scroll+"]").offset().top;
		totop = totop - 50;
		$('html, body').stop().animate({
	      scrollTop: totop
	  }, 1000);
	});

	$(window).scroll(function (event) {
		if (page == 'formation_detail_view') {
			fixer_side();
			animate_link_side();
	  }
	});

 function animate_link_side(){
		var scroll = $(window).scrollTop();
		var top_1 = $(".side_content h1[data-scroll='1']").offset().top;
		var top_2 = $(".side_content h1[data-scroll='2']").offset().top + 50;
		var top_3 = $(".side_content h1[data-scroll='3']").offset().top + 50;
		var top_4 = $(".side_content h1[data-scroll='4']").offset().top + 50;
		if (scroll < top_1) {
			$('.cta_aside').removeClass('active');
			$('.cta_aside[data-scroll="1"]').addClass('active');
		}
		if (scroll > top_1) {
			$('.cta_aside').removeClass('active');
			$('.cta_aside[data-scroll="2"]').addClass('active');
			if (scroll > top_2) {
				$('.cta_aside').removeClass('active');
				$('.cta_aside[data-scroll="3"]').addClass('active');
				if (scroll > top_3) {
					$('.cta_aside').removeClass('active');
					$('.cta_aside[data-scroll="4"]').addClass('active');
				}
			}
		}
 }

 function fixer_side(){
	 var top_start = $(".side_content").offset().top;
	 top_start = top_start - 20;
	 var scroll = $(window).scrollTop();
	 var sideSize = $(".side_bar").height();
	 var end = $(".section_formation_content").position().top + $(".side_content").outerHeight(true) - sideSize + 100;
	 if (scroll >= top_start) {
		 if (scroll >= end) {
			 $(".side_bar").removeClass('fixed');
			 $(".side_bar").addClass('bottom');
		 } else {
			 $(".side_bar").removeClass('bottom');
			 $(".side_bar").addClass('fixed');
		 }
	 } else {
		 $(".side_bar").removeClass('fixed');
		 $(".side_bar").removeClass('bottom');
	 }
 }


 ////////////////////
 // Page formation change
 ////////////////////

if (page == 'formation_view') {
	startFilter();
	cutString();
	fontChange();
	if ($(".canscrollinto").length) {
		var totop = $(".canscrollinto").offset().top;
		totop = totop - 150;
		$('html, body').stop().animate({ scrollTop: totop }, 600);
	}else {
		// console.log('no scroooooool');
	}
}
// Cut long string
function cutString(){
	var length = 100;
	$(".cf_copy").each(function() {
		var oldcopy = $(this).text();
		var newCopy = '';
		if (oldcopy.length > length) {
	    newCopy = oldcopy.substr(0, length) + '\u2026';
			$(this).text(newCopy);
	  }
	});
}
// Font size changer
function fontChange(){
	var length = 27;
	$(".cf_title").each(function() {
		var nbrLetter = $(this).text().length;
		if (nbrLetter > length) {
			$(this).addClass("liter");
		}
	});
}

////////////////////
// Filtre FILTER
////////////////////

function startFilter(){
	$('.filter_btn').selectric();
	var selectedInputStart = $('.filter_btn').find('option:selected').not("[value='all']");
	var value = selectedInputStart.val();
	var select = selectedInputStart.data("select");
	var valuetxt = selectedInputStart.text();
	if (selectedInputStart.length) {
		tagCreation(select, value, valuetxt);
		createReset();
		filter();
	}
}

$('.filter_btn').on('change', function() {
	var value = $(this).val();
	var select = $(this).attr("name");
	var valuetxt = $(this).find('option:selected').text();
	tagCreation(select, value, valuetxt);
	isFilterReset();
	filter();
});

$('body').on('click', '.tag', function () {
	var elem = $(this);
	var value = $(this).data("id");
	var select = $(this).data("select");
	var valuetxt = $(this).text();
	if (select == "reset") {
		resetFilter();
	}else {
		tagClose(elem, select, value, valuetxt);
	}
	filter();
});

function tagCreation(select, value, valuetxt){
	$(".tag[data-select='"+select+"']").remove();
	if (value != "all") {
		var newTag = "<span class='tag' data-select="+select+" data-id="+value+">"+valuetxt+"</span>" ;
		createReset();
		$(newTag).insertBefore(".tag[data-select='reset']");
	}
}

function tagClose(elem, select, value, valuetxt){
	elem.remove();
	$('.filter_btn[name="'+select+'"]').prop('selectedIndex', 0).selectric('refresh');
	if (!$(".tag").not("[data-select='reset']").length) {
		resetFilter();
	}
}

function createReset(){
	var resetTag = "<span class='tag' data-select='reset'>Remettre le filtre à zero</span>";
	if (!$(".tag[data-select='reset']").length) {
		$(resetTag).appendTo('.tag_list');
	}
}

function isFilterReset(){
	var errorReset = 0;
	$("select").each(function() {
		var selected = $(this).find('option:selected').val();
		if (selected == 'all') {
			errorReset++;
		}
	});
	if (errorReset == 4) {
		resetFilter();
	}
}

function resetFilter(){
	$(".tag").remove();
	$('.filter_btn').prop('selectedIndex', 0).selectric('refresh');
}

function filter(){
	var filter = [];
	$("select").each(function() {
		var name = $(this).attr('name');
		var selected = $(this).find('option:selected').val();
		filter.push(selected);
	});

	$(".formation_link").each(function() {
		var errorTab = 0;
		var type = $(this).data('type');
		var timing = $(this).data('timing');
		var lieu = $(this).data('lieu');
		var formation = $(this).data('formation');

		// à changer (condition via data)
		if (filter[0] != 'all' && filter[0]!=formation) {
			errorTab++;
		}if (filter[1] != 'all' && filter[1]!=type) {
			errorTab++;
		}if (filter[2] != 'all' && filter[2]!=timing) {
			errorTab++;
		}if (filter[3] != 'all' && filter[3]!=lieu) {
			errorTab++;
		}
		// END - à changer (condition via data)
		if (errorTab == 0) {
			$(this).removeClass('notActive');
		} else {
			$(this).addClass('notActive')
		}
	});
	filterNoResult();
}

function filterNoResult(){
	var notActive = $(".formation_link:not(.notActive)").length;
	if (notActive == 0) {
		$('.error_filtre').show();
	}else {
		$('.error_filtre').hide();
	}
}




////////////////////
// Check Form
////////////////////

// Optin
$('.checkbox_parent').click(function(e){
	e.preventDefault();
	var id = $(this).data('id');
	if ($(this).hasClass('active')) {
		$(this).addClass('error');
		$(this).removeClass('active');
		$(this).find('.checkbox').removeClass('active');
		$("input[name='"+id+"']").val('0');
	} else {
		$(this).removeClass('error');
		$(this).addClass('active');
		$(this).find('.checkbox').addClass('active');
		$("input[name='"+id+"']").val('1');
	}
});

// Force Number
$('.to_hide').on('change', function() {
	var data = $(this).data("hided");
	var value = $(this).find('option:selected').val();
	if (value == '1') {
		$(".input_line[data-hided='"+data+"']").not('.no_hide').removeClass('hided');
	}else {
		$(".input_line[data-hided='"+data+"']").not('.no_hide').addClass('hided');
	}
});


// Force Number
	$(".num").on("keyup keypress keydown focusout blur", function() {
		this.value = this.value.replace(/[^0-9]/g, '');
	});

	// Force maske on date
	$('.datemask').mask("00/00/0000", {placeholder: "__/__/____"});

// Check Form
	var verifmail = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
	var verifphone = /^[0-9 \-\/\(\)]{9,19}$/;

	function checkForm(form, btn, url) {
		var erreur = 0;
		var form = $(form);
		var id_form = form.data("form");
		var is_custom = form.data("custom");
		var is_stepper = form.data("stepper");
		if (is_stepper) {
			var step = form.find(".step_form:visible").data("step");
			var stepperMax = form.data("steppermax");
		}
		var btn = $(btn);

		form.find('.required').not(".checkbox_parent, .radio_parent").each(function() {
			if ($(this).is(':visible')) {
				if ($(this).val() == '' || $(this).val() == null) {
					$(this).addClass("error");
					erreur++;
				} else {
					$(this).removeClass("error");
				}
			}
			form.find('.mail.required').each(function() {
				if ($(this).is(':visible')) {
					if (verifmail.exec($(this).val()) == null) {
						$(this).addClass("error");
						erreur++;
					} else {
						$(this).removeClass("error");
					}
				}
			});
		});

		form.find('.checkbox_parent.required').each(function() {
			if ($(this).is(':visible')) {
				if (!$(this).find(".checkbox.active").length) {
					$(this).addClass("error");
					erreur++;
				} else {
					$(this).removeClass("error");
				}
			}
		});

		form.find('.selectric-required').each(function() {
			if ($(this).is(':visible')) {
				var val_inner = $(this).find("li.selected").text();
				if (val_inner == '...') {
					$(this).parent('.input_line').addClass('error');
					erreur++;
				}else {
					$(this).parent('.input_line').removeClass('error');
				}
				// if ($(this).find("option.active").length) {
				// 	$(this).addClass("error");
				// 	erreur++;
				// } else {
				// 	$(this).removeClass("error");
				// }
			}
		});

		form.find('.radio_parent.required').each(function() {
			if ($(this).is(':visible')) {
				if (!$(this).find(".radio.active").length) {
					$(this).addClass("error");
					erreur++;
				} else {
					$(this).removeClass("error");
				}
			}
		});

		form.find('.required').not(".checkbox_parent, .radio_parent").focusout(function() {
			if ($(this).is(':visible')) {
				if ($(this).hasClass("mail required")) {
					if (verifmail.exec($(this).val()) == null) {
						$(this).addClass("error");
						erreur++;
					} else {
						$(this).removeClass("error");
					}
				} else {
					if ($(this).val() == '' || $(this).val() == null) {
						$(this).addClass("error");
						erreur++;
					} else {
						$(this).removeClass("error");
					}
				}
			}
		});

		if (is_custom) {
			erreur = parseInt(checkCustom(id_form, erreur));
		}

		if (erreur == 0 && !btn.hasClass("disabled")) {
			form.find(".error_message").hide();
			if (is_stepper) {
				if (step == stepperMax) {
					grecaptcha.ready(function() {
					  grecaptcha.execute('6LeMcA8cAAAAAJfl_5zqSnZVj_IbpQ144CzYJfYq', {action: 'submit'}).then(function(token) {
								$('input[name="token"]').val(token);
								ajaxForm(form, btn, url);
					  });
					});
				}else {
					switchStep(step);
				}
			}else{
				grecaptcha.ready(function() {
					grecaptcha.execute('6LeMcA8cAAAAAJfl_5zqSnZVj_IbpQ144CzYJfYq', {action: 'submit'}).then(function(token) {
							$('input[name="token"]').val(token);
							ajaxForm(form, btn, url);
					});
				});
			}
		} else {
			$('html, body').animate({ scrollTop: $(".error").offset().top - 50 }, 300);
			form.find(".error_message--all").show();
		}

	}

	function switchStep(step){
		var toStep = step + 1;
		$(".step_form[data-step='"+step+"']").fadeOut( "slow", function() {
			$(".step_form[data-step='"+toStep+"']").fadeIn( "slow", function() {
				$('html, body').animate({ scrollTop: $('#target').offset().top }, 300);
			});
		});
	}

	function ajaxForm(form, btn, url) {
		$(".message_error").hide();
		var form = $(form);
		var id_form = form.data("form");
		var btn = $(btn);
		btn.addClass("disabled");
		var fields = form.serialize();
		console.log(fields);
		$.ajax({
			type: "POST",
			data: fields,
			url: url,
			success: function(data) {
				btn.removeClass("disabled");
				var datas = data.hasOwnProperty('responseJSON') ? data.responseJSON : [];
				afterSendOk(id_form, datas);
			},
			error: function(error) {
				btn.removeClass('disabled');
				var errors = error.hasOwnProperty('responseJSON') ? error.responseJSON : [];
				afterSendNotOk(errors, id_form);
			}
		});
	}

	$(".js_verif").click(function(e) {
		e.preventDefault();
		var id = $(this).data("form");
		var form = $("form[data-form=" + id + "]");
		var url = form.attr("action");
		var btn = $(this);
		checkForm(form, btn, url);
	});


	function afterSendOk(form, datas) {
		switch (form) {
			case "contact":
				$(".form").fadeOut('slow', function(){
					var top = $(".scroll_top_form").offset().top;
					top = top - 50;
					$('html, body').animate({ scrollTop: top}, 600);
					$(".ender_form").fadeIn('slow');
				});
				break;
			case "subscription":
				$(".form").fadeOut('slow', function(){
					var top = $(".scroll_top_form").offset().top;
					top = top - 50;
					$('html, body').animate({ scrollTop: top}, 600);
					$(".ender_form").fadeIn('slow');
				});
				break;
		}
	}

	function afterSendNotOk(retour, form) {
		switch (form) {
			case "contact":
				$(".form").fadeOut('slow', function(){
					$('.error_message--prob').show();
					// var top = $("."+retour[0]['field']+"").offset().top;
					// top = top - 50;
					// $('html, body').animate({ scrollTop: top}, 600);
				});
				break;
			case "subscription":
				$(".form").fadeOut('slow', function(){
					$('.error_message--prob').show();
				});
				break;
		}
	}

	function checkCustom(form, erreur) {
		var erreurC = 0;
		switch (form) {
			case "contact":
				if (!customMailPhone()) {
					erreurC = 1;
				}
				erreurC = erreur + erreurC;
				return erreurC;
				break;
			default:
				erreur = 1;
				break;
		}
		return erreur;
	}

	function customMailPhone() {
		var erreurC = 0;
		var count = 0;

		if ($('.mail').val() != '' && $('.mail').val() != null) {
			count++;
			if (verifmail.exec($('.mail').val()) == null) {
				erreurC++;
			}
		}

		if ($('.phone').val() != '' && $('.phone').val() != null) {
			count++;
			// if (false) {
			// 	erreurC++;
			// }
		}

		if (erreurC == 0 && count > 0) {
			$('.mail, .phone').removeClass('error');
			return true;
		}else {
			$('.mail, .phone').addClass('error');
			return false;
		}
	}

// cookies
$('.close_cookie').click(function(e) {
	e.preventDefault();
	$('.cookies_settings').fadeOut('300');
})
$('.cookie_ok').click(function(e) {
	e.preventDefault();
	create_cookie('cookie_settings', '1', 15);
	$('.cookies_settings').fadeOut('300');
})

function create_cookie(name, value, days){
	var date = new Date();
  date.setTime(date.getTime() + (days*24*60*60*1000));
	date = date.toUTCString();
	document.cookie = name+`=`+value+`; expires=`+date;
}

/////////////////////
// Animation start
////////////////////
	function fade_In_Content(){
		$('.banner_top').addClass('fade_in');
		$('.to_fade_in').addClass('fade_in_2');
	}

	fade_In_Content();

// APPEAR fadeIn
	// if ($('.starter_pack').is(':visible')) {
	// 	var tl = gsap.timeline({onComplete: finished_anim});
	// 	tl.set(".content_anim", {scale: 0.5});
	// 	tl.set(".triangle", {rotation: 180, opacity: 0});
	// 	tl.set(".gimmiks", {rotation: -180, scale: 0, opacity: 0});
	// 	tl.to(".triangle", {rotation: 0, opacity: 1, scale: 1, duration: .5, ease: Elastic.easeOut.config(1, 0.75)});
	// 	tl.staggerTo(".triangles", .6, {top: 20, opacity: 0, rotation: 50, ease: Elastic.easeOut.config(1, 0.75)}, 0.1);
	// 	tl.staggerTo(".ronds", .3, {opacity: 1, scale: 1, ease: Elastic.easeOut.config(1, 0.75)}, 0.1, '-=.4');
	// 	tl.to(".rond", {scale:0, opacity: 0, duration: .6, ease: Back.easeIn.config(3)}, 1.4);
	// 	tl.to(".cercles_1", {opacity: 1, scale: 1, duration: .6, ease: Elastic.easeOut.config(1, 0.75)});
	// 	tl.to(".cercles_2", {opacity: 1, scale: 1, duration: .8, ease: Elastic.easeOut.config(1, 1)}, '-=.6');
	// 	tl.to(".cercle", {scale: .7, opacity: 0, duration: .4, ease: Back.easeIn.config(3)});
	// 	tl.to(".scalier_inner", {width: '160%', duration: .6, ease: Sine.easeOut}, '-=.2');
	// 	tl.to(".scalier_inner", {height: '0', duration: .5, ease: Sine.easeIn}, '-=.2');
	// 	tl.staggerTo(".mounts", .4, {opacity: 1, scale: 1, ease: Elastic.easeOut.config(1, 0.75)}, 0.1, '-=.4');
	// 	tl.staggerTo(".mounts", .4, {opacity: 0, scale: 0, ease: Back.easeIn.config(1)}, 0.1);
	// 	tl.to(".gimmiks", {rotation: 0, scale: 1, opacity: 1, duration: .8, ease:  Elastic.easeOut.config(1, 0.75)}, '-=.1');
	// 	tl.to(".gimmiks", {opacity: 0, duration: .7, ease: Sine.easeIn});
	// 	tl.to(".starter_pack", {scale: 0, duration: 1, ease:Back.easeIn.config(1)}, '-=.6');
	// 	tl.pause();
	// }

	// function finished_anim(){
	// 	fade_In_Content();
	// 	create_cookie('animation', '1', 7);
	// }

	// if (getCookie('animation') != 1) {
	// 	tl.play();
	// }else {
	// 	fade_In_Content();
	// }



// MODAL box
function modal_open(elem, id){
	elem.addClass('active');
	$('.modal[data-id="'+id+'"]').stop().fadeIn('300');
}
function modal_close(elem, id){
	elem.removeClass('active');
	$('.modal[data-id="'+id+'"]').stop().fadeOut('300');
}
$('.lsc_toggle').click(function(e){
	e.preventDefault();
	var id = $(this).data("id");
	var elem = $(this);
	if (elem.hasClass('active')) {
		modal_close(elem, id);
	}else {
		modal_open(elem, id);
	}
})

$('.close_modal, .bg_behind_modal').click(function(e){
	e.preventDefault();
	var id = $(this).data("id");
	var elem = $('.lsc_toggle[data-id="'+id+'"]');
	modal_close(elem, id);
})


});
